export default "__VITE_ASSET__DDEmFcix__"